import * as colors from 'constants/colors';
import styled from "styled-components";
export const Container = styled.tr`
`

export const OptionsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 120px);
`

export const TdDescription = styled.td`
  padding: 0;
`

export const Td = styled.td`
  padding: 0;
  @media (min-width: 500px) {
    width: 50px;
  }
`

export const Description = styled.p`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
  padding: 10px;
  margin: 0;
`

export const Label = styled.label<{
  error: string | undefined
  checked: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 5px;
  width: 100%;
  height: 100%;
  cursor: pointer;
  &:before {
    content: '';
    background: ${({ checked }) => checked ? colors.primary01 : '#F4F5F8'};
    border-radius: 100%;
    border: 1px solid ${({ error, checked }) => checked ? colors.primary01 : error ? 'red' : '#a6aec6'};
    display: inline-block;
    width: 23px;
    height: 23px;
    position: relative;
    top: 0;
    vertical-align: top;
    cursor: pointer;
    text-align: center;
    -webkit-transition: all 250ms ease;
    transition: all 250ms ease;
    display: inline-block;
    vertical-align: middle;
    box-shadow: ${({ checked }) => checked ? 'inset 0 0 0 4px #F4F5F8' : 'none'};
  }
`

export const Input = styled.input`
  width: 24px;
  height: 24px;
  position: absolute;
  cursor: pointer;
  opacity: 0;
`

export const Error = styled.span`
  display: grid;
  place-items: center;
  background: red;
  color: #fff;
  border-radius: 50%;
  font-weight: 600;
  font-size: 12px;
  width: 19px;
  height: 19px;
`